export default __webpack_public_path__ + "static/media/about.59b4088b.png";